module.exports = __webpack_public_path__ + "static/media/top-logo-902-en-1.75a36d01.png";